// removed by extract-text-webpack-plugin
module.exports = {"Button":"-name__-loca-__QI7b2","Success":"-name__-loca-__2dHUt","Danger":"-name__-loca-__2xnhN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Button/Button.css
// module id = 161
// module chunks = 0